import { TimelineMax, Expo } from 'gsap';

export default function breadcrumb(el, dir) {
  const tl = new TimelineMax({
    paused: true,
  });

  const line = el.querySelector('.breadcrumbs__line');
  const link = el.querySelector('.breadcrumbs__link');

  if (dir === 'next') {
    tl
    .addLabel('start')
    .to(line, 0.5, {
      scaleX: 0.5,
      transformOrigin: '100% 50%',
      ease: Expo.easeOut,
    }, 'start')
  } else {
    tl
    .addLabel('start')
    .to(line, 0.5, {
      scaleX: 0.5,
      transformOrigin: '0% 50%',
      ease: Expo.easeOut,
    }, 'start')
  }

  return tl;
}
